/* Candela presentation adapter. Releasit remains the only checkout/order owner. */
(function () {
  'use strict';
  const HANDLE = 'candela-300-ml-regalo-1';
  const PRODUCT_SELECTOR = '[data-cu-candela-product="' + HANDLE + '"]';
  const MODAL_SELECTOR = '#rsi_form_wrapper, #_rsi-cod-form-modal';
  const NATIVE_OFFER_SELECTOR = 'label.rsi-quantity-product';
  const LEGACY_OFFER_SELECTOR = '._rsi-quantity-offers-offer-container[data-offer-pos]';
  const FORM_SELECTOR = 'form.rsi-form-main, form#_rsi-cod-form-modal-form._rsi-modal-form';
  const OWN_PREFIX = 'data-cu-candela-cod';
  const configElement = document.getElementById('cu-candela-cod-config');
  let config = {};
  try { config = JSON.parse(configElement ? configElement.textContent : '{}'); } catch (_) {}
  if (config.handle !== HANDLE || !document.querySelector(PRODUCT_SELECTOR)) return;
  if (window.CosaUtilCandelaCOD) return;

  let pendingQuantity = null;
  let selectionDeadline = 0;
  let queued = false;
  let statusTimer = null;
  const presentationStyles = new Map();
  const packImageStates = new Map();
  const confirmationStates = new Map();
  let confirmationChoice = null;
  let applyingConfirmationDefault = false;
  let floatingButton = null;
  const fieldPlaceholders = new Map();
  const layoutStates = new Map();
  const pathMatches = () => new RegExp('/products/' + HANDLE + '/?$').test(window.location.pathname);
  const activeProduct = () => pathMatches() && document.querySelector(PRODUCT_SELECTOR);
  const visible = node => Boolean(node && node.isConnected && !node.closest('[hidden]') && node.getClientRects().length && getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden');
  const setAttribute = (node, name, value) => { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); };
  const addClass = (node, name) => { if (node && !node.classList.contains(name)) node.classList.add(name); };
  const isLegacy = modal => modal && modal.id === '_rsi-cod-form-modal';
  const openModal = () => Array.from(document.querySelectorAll(MODAL_SELECTOR)).find(modal => visible(modal) && (isLegacy(modal) ? modal.classList.contains('_rsi-cod-form-modal-open') : !('open' in modal) || modal.open)) || null;

  // Legacy Releasit emits inline !important green. Presentation-only overrides
  // are snapshotted and restored when leaving this product; business data is not.
  function presentationStyle(node, property, value) {
    if (!node) return;
    let state = presentationStyles.get(node);
    if (!state) { state = new Map(); presentationStyles.set(node, state); }
    const previous = state.get(property);
    if (previous && previous.requested === value && node.style.getPropertyValue(property) === previous.after && node.style.getPropertyPriority(property) === 'important') return;
    if (!state.has(property)) state.set(property, {before: node.style.getPropertyValue(property), priority: node.style.getPropertyPriority(property), requested: value, after: ''});
    else state.get(property).requested = value;
    node.style.setProperty(property, value, 'important');
    state.get(property).after = node.style.getPropertyValue(property);
  }

  function restorePresentationStyles() {
    presentationStyles.forEach((properties, node) => {
      properties.forEach((state, property) => {
        if (node.style.getPropertyValue(property) !== state.after) return;
        if (state.before) node.style.setProperty(property, state.before, state.priority);
        else node.style.removeProperty(property);
      });
    });
    presentationStyles.clear();
  }

  // Read the landing selection. Never writes a quantity, variant, price or address.
  function selectedQuantity() {
    const product = activeProduct();
    const input = product && product.querySelector('[data-me-qb] input[name="me-qty"]:checked');
    const card = input && input.closest('[data-qty]');
    const quantity = Number(card && card.getAttribute('data-qty'));
    return Number.isInteger(quantity) && quantity > 0 ? quantity : null;
  }

  function quantityFromTitle(text) {
    const clean = String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const match = clean.match(/(?:^|\s)([1-9]\d*)\s*(?:unidad(?:es)?|tarros?|frascos?|cremas?)\b/i);
    return match ? Number(match[1]) : null;
  }

  function status(message) {
    const product = activeProduct();
    if (!product) return;
    let note = product.querySelector('[data-cu-candela-cod-status]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'cu-candela-cod-status';
      note.setAttribute('data-cu-candela-cod-status', '');
      note.setAttribute('role', 'status');
      const button = product.querySelector('[data-cu-candela-cod-open]');
      if (button) button.insertAdjacentElement('afterend', note);
    }
    if (note && note.textContent !== message) note.textContent = message;
  }

  // Only real native, visible product buttons are eligible. Never call a guessed
  // SDK function, click the modal submit, or fall back to /cart/add or /checkout.
  function nativeOpener() {
    const selectors = [];
    if (typeof config.nativeOpenerSelector === 'string' && config.nativeOpenerSelector.trim()) selectors.push(config.nativeOpenerSelector.trim());
    selectors.push('#_rsi-buy-now-button._rsi-buy-now-button-product', '._rsi-buy-now-button'); // Live Candela product opener, confirmed 2026-10-16.
    for (const selector of selectors) {
      let candidates = [];
      try { candidates = Array.from(document.querySelectorAll(selector)); } catch (_) { continue; }
      const button = candidates.find(node => visible(node) && !node.closest(MODAL_SELECTOR + ', ._rsi-modal-container, ._rsi-modal-form') && !node.matches('[data-cu-candela-cod-open], .rsi-submit_button') && !node.disabled && node.getAttribute('aria-disabled') !== 'true');
      if (button) return button;
    }
    return null;
  }

  function open() {
    if (!activeProduct()) return false;
    const opener = nativeOpener();
    if (!opener) {
      status('El formulario de pago contra entrega todavía está cargando. Espera un momento e inténtalo de nuevo.');
      return false;
    }
    pendingQuantity = selectedQuantity();
    selectionDeadline = Date.now() + 6000;
    status('');
    opener.click();
    schedule();
    clearTimeout(statusTimer);
    statusTimer = setTimeout(() => {
      const modal = openModal();
      if (!modal || !visible(modal)) status('No se pudo abrir el formulario. Recarga la página y vuelve a intentarlo.');
    }, 4500);
    return true;
  }

  // UI selection, once per opening. It clicks the real native radio/offer; it does
  // not set checked/value, calculate a discount, or keep overriding customer edits.
  function applyRequestedOffer(modal) {
    if (pendingQuantity == null) return;
    if (Date.now() > selectionDeadline) { pendingQuantity = null; return; }
    const legacy = isLegacy(modal);
    const choices = Array.from(modal.querySelectorAll(legacy ? LEGACY_OFFER_SELECTOR : NATIVE_OFFER_SELECTOR)).filter(visible);
    const matching = choices.filter(label => quantityFromTitle(label.querySelector(legacy ? '._rsi-quantity-offers-title' : '.rsi-quantity-title')?.textContent) === pendingQuantity);
    if (matching.length !== 1) return;
    if (legacy) {
      const selected = matching[0].classList.contains('_rsi-quantity-offers-selected') || matching[0].querySelector('._rsi-quantity-offers-selected');
      if (selected) { pendingQuantity = null; return; }
      const target = matching[0].querySelector('._rsi-quantity-offers-offer');
      if (!target) return;
      // The existing me-quantity-breaks integration uses this exact native pointer
      // sequence on the inner legacy offer, not on its wrapper. Never changes its
      // hidden item_quantity/item_variant_id controls directly.
      ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(type => {
        target.dispatchEvent(new MouseEvent(type, {bubbles: true, cancelable: true, view: window}));
      });
      return;
    }
    const radio = matching[0].querySelector('input[id^="quantity_offer_"]');
    if (!radio || radio.disabled || radio.getAttribute('aria-disabled') === 'true') return;
    if (radio.checked) { pendingQuantity = null; return; }
    radio.click();
    // A native state update may be asynchronous; a fresh observed render verifies
    // the selected radio. No fake input/change events are synthesized.
  }

  function icon(name) {
    const paths = {
      truck: '<path d="M3 7h11v10H3zM14 11h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
      cash: '<path d="M3 6h18v12H3z"/><circle cx="12" cy="12" r="3"/><path d="M6 9h.01M18 15h.01"/>',
      shield: '<path d="M12 3 4 6v6c0 4 5 8 8 9 3-1 8-5 8-9V6z"/><path d="m8 12 3 3 5-6"/>',
      user: '<circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/>',
      phone: '<path d="m7 3 3 5-2 2a17 17 0 0 0 6 6l2-2 5 3-1 4c-9 1-18-8-17-17z"/>',
      pin: '<path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z"/><circle cx="12" cy="10" r="2"/>',
      home: '<path d="m3 11 9-8 9 8M5 10v11h14V10M10 21v-7h4v7"/>',
      note: '<path d="M5 3h14v18H5zM8 8h8M8 12h8M8 16h5"/>',
      star: '<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9z"/>',
      cart: '<path d="M2 3h3l3 12h10l3-8H6"/><circle cx="9" cy="19" r="1"/><circle cx="18" cy="19" r="1"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths[name] + '</svg>';
  }

  function syncFloatingButton(opener, modal) {
    if (!floatingButton) {
      floatingButton = document.createElement('button');
      floatingButton.type = 'button';
      floatingButton.className = 'cu-candela-floating cu-candela-cta-motion';
      floatingButton.hidden = true;
      floatingButton.setAttribute('data-cu-candela-floating', '');
      floatingButton.setAttribute('aria-label', 'Pedir CANDELA contra entrega');
      floatingButton.innerHTML = icon('cash') + '<span><strong>Pedir contra entrega</strong><small>Sin anticipos · pagas al recibir</small></span>';
      // The same verified opener captures the landing pack and opens Releasit.
      // This button is never a form submit and never calls checkout/cart APIs.
      floatingButton.addEventListener('click', open);
      document.body.appendChild(floatingButton);
    }
    const rect = opener && opener.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const keyboardOpen = window.visualViewport && window.visualViewport.height < viewportHeight * .75;
    const shouldShow = Boolean(opener && rect && rect.bottom <= 0 && !modal && !keyboardOpen);
    if (floatingButton.hidden === shouldShow) floatingButton.hidden = !shouldShow;
    // A store-admin preview toolbar is not present for customers. Keep the
    // floating control above it when it is present during store-owner testing.
    const preview = document.getElementById('PBarNextFrame');
    const previewRect = preview && preview.getBoundingClientRect();
    const previewOffset = previewRect && previewRect.width > 0 && previewRect.height > 0 && previewRect.bottom >= viewportHeight - 2
      ? (previewRect.height < 150 ? Math.max(0, Math.min(120, viewportHeight - previewRect.top)) : 64) : 0;
    const offset = Math.round(previewOffset) + 'px';
    if (floatingButton.style.getPropertyValue('--cu-floating-preview-offset') !== offset) floatingButton.style.setProperty('--cu-floating-preview-offset', offset);
  }

  function restoreFieldPlaceholders() {
    fieldPlaceholders.forEach((state, input) => {
      if (input.getAttribute('placeholder') !== state.applied) return;
      if (state.before == null) input.removeAttribute('placeholder');
      else input.setAttribute('placeholder', state.before);
    });
    fieldPlaceholders.clear();
  }

  function layoutState(modal) {
    if (!layoutStates.has(modal)) layoutStates.set(modal, {snapshots: [], moves: [], attributes: [], texts: []});
    return layoutStates.get(modal);
  }

  function rememberContainer(state, container) {
    if (!state.snapshots.some(entry => entry.container === container)) state.snapshots.push({container, nodes: Array.from(container.childNodes)});
  }

  function ownAttribute(state, node, name, value) {
    if (!node || node.getAttribute(name) === value) return;
    let entry = state.attributes.find(item => item.node === node && item.name === name);
    if (!entry) { entry = {node, name, before: node.getAttribute(name), after: value}; state.attributes.push(entry); }
    else entry.after = value;
    node.setAttribute(name, value);
  }

  function ownText(state, node, value) {
    if (!node || node.nodeType !== Node.TEXT_NODE || node.nodeValue === value) return;
    let entry = state.texts.find(item => item.node === node);
    if (!entry) { entry = {node, before: node.nodeValue, after: value}; state.texts.push(entry); }
    else entry.after = value;
    node.nodeValue = value;
  }

  const directText = node => node && Array.from(node.childNodes).find(child => child.nodeType === Node.TEXT_NODE && child.nodeValue.trim());

  function topBlock(container, node) {
    while (node && node.parentElement !== container) node = node.parentElement;
    return node && node.parentElement === container ? node : null;
  }

  function moveNative(state, node, parent, anchor) {
    if (!node || (node.parentElement === parent && node.nextSibling === anchor)) return;
    if (!state.moves.some(entry => entry.node === node)) state.moves.push({node, parent: node.parentElement, next: node.nextSibling});
    parent.insertBefore(node, anchor);
  }

  function placeOrder(container, nodes) {
    let anchor = null;
    for (let index = nodes.length - 1; index >= 0; index -= 1) {
      if (nodes[index].parentElement !== container || nodes[index].nextSibling !== anchor) container.insertBefore(nodes[index], anchor);
      anchor = nodes[index];
    }
  }

  function relativeOrder(container, nodes) {
    const children = Array.from(container.childNodes);
    let previous = -1;
    return nodes.every(node => {
      const index = children.indexOf(node);
      if (index <= previous) return false;
      previous = index;
      return true;
    });
  }

  function deliveryNote(container) {
    return Array.from(container.children).find(node => {
      const text = node.matches('.rsi-custom-text, ._rsi-modal-custom-text, ._rsi-build-block-custom-text') ? node : node.querySelector('.rsi-custom-text, ._rsi-modal-custom-text, ._rsi-build-block-custom-text');
      return text && /^(Completa tus datos de entrega|Ingrese su dirección de envío)$/.test(text.textContent.trim()) && !node.querySelector('input,select,textarea,button');
    });
  }

  function preserveFocus(modal, operation) {
    const active = document.activeElement;
    const keep = active && modal.contains(active);
    let selection = null;
    try { if (keep && typeof active.selectionStart === 'number') selection = [active.selectionStart, active.selectionEnd, active.selectionDirection]; } catch (_) {}
    operation();
    if (keep && active.isConnected && document.activeElement !== active) {
      active.focus({preventScroll: true});
      if (selection) try { active.setSelectionRange(...selection); } catch (_) {}
    }
  }

  function fieldBlocks(container, legacy) {
    // last_name and note are genuine shared app fields when enabled. Keep the
    // old six-field form supported; never create a missing control.
    return ['first_name', 'last_name', 'phone', 'province_country_field', 'city', 'address', 'civic_number', 'note'].filter(name =>
      !['last_name', 'note'].includes(name) || container.querySelector('[id="' + (legacy ? '_rsi-field-' : '') + name + '"]')
    ).map(name => {
      const controls = container.querySelectorAll('[id="' + (legacy ? '_rsi-field-' : '') + name + '"]');
      return controls.length === 1 ? topBlock(container, controls[0]) : null;
    });
  }

  function fieldsWithDeliveryNote(container, legacy, fields, note) {
    const ordered = fields.slice();
    if (note) {
      const phone = container.querySelector('[id="' + (legacy ? '_rsi-field-' : '') + 'phone"]');
      const phoneIndex = fields.indexOf(topBlock(container, phone));
      ordered.splice(phoneIndex < 0 ? 0 : phoneIndex + 1, 0, note);
    }
    return ordered;
  }

  function reorderDelivery(state, container, legacy) {
    const fields = fieldBlocks(container, legacy);
    if (fields.some(node => !node) || new Set(fields).size !== fields.length) return false;
    const knownNote = deliveryNote(container);
    const checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]')).map(input => topBlock(container, input)).filter((node, index, all) => node && !fields.includes(node) && all.indexOf(node) === index);
    const known = fields.concat(knownNote ? [knownNote] : [], checkboxes);
    const desired = fieldsWithDeliveryNote(container, legacy, fields, knownNote);
    desired.push(...checkboxes);
    let index = 0;
    const arranged = Array.from(container.childNodes).map(node => known.includes(node) ? desired[index++] : node);
    rememberContainer(state, container);
    placeOrder(container, arranged);
    if (knownNote) {
      const note = knownNote.matches('.rsi-custom-text, ._rsi-modal-custom-text, ._rsi-build-block-custom-text') ? knownNote : knownNote.querySelector('.rsi-custom-text, ._rsi-modal-custom-text, ._rsi-build-block-custom-text');
      ownText(state, directText(note.querySelector('._rsi-custom-text-field, span') || note), 'Ingrese su dirección de envío');
    }
    const hasLastName = Boolean(container.querySelector('[id="' + (legacy ? '_rsi-field-' : '') + 'last_name"]'));
    const hasReference = Boolean(container.querySelector('[id="' + (legacy ? '_rsi-field-' : '') + 'note"]'));
    const labels = {first_name: hasLastName ? 'Nombre' : 'Nombre Apellido', last_name: 'Apellido', phone: 'WhatsApp principal', address: 'Dirección', civic_number: hasReference ? 'Barrio' : 'Complemento', note: 'Dirección de referencia'};
    Object.keys(labels).forEach(name => {
      const id = (legacy ? '_rsi-field-' : '') + name;
      const control = container.querySelector('[id="' + id + '"]');
      const wrapper = control && control.closest('.rsi-text-input-wrapper, ._rsi-modal-fields-item');
      const label = wrapper && wrapper.querySelector('label');
      if (label) ownText(state, directText(label), labels[name]);
    });
    return true;
  }

  // Only whole native blocks move. All unknown siblings/controls, provider IDs,
  // names, values and listeners are retained, as in the LED reference template.
  function orderNativeBlocks(modal, form) {
    const state = layoutState(modal);
    const legacy = isLegacy(modal);
    preserveFocus(modal, () => {
      if (legacy) {
        const offersNode = form.querySelector(LEGACY_OFFER_SELECTOR);
        const summaryNode = form.querySelector('._rsi-build-block-totals-summary');
        const shippingNode = form.querySelector('._rsi-build-block-shipping-rates, ._rsi-shipping-rates-wrapper, ._rsi-modal-shipping-rates');
        const submitNode = form.querySelector('button._rsi-modal-submit-button[type="submit"]');
        if (!offersNode || !summaryNode || !submitNode) return;
        // Find the shared native layout rather than assuming an app version's
        // wrapper depth; stop if any required block shares a wrapper with fields.
        let layout = form.querySelector('[id="_rsi-field-first_name"]')?.closest('._rsi-modal-fields-item')?.parentElement;
        while (layout && layout !== form && !layout.contains(offersNode)) layout = layout.parentElement;
        if (!layout || !form.contains(layout)) return;
        const fields = fieldBlocks(layout, true);
        const offers = topBlock(layout, offersNode), summary = topBlock(layout, summaryNode), submit = topBlock(layout, submitNode);
        const shipping = shippingNode && topBlock(layout, shippingNode);
        const known = [offers, summary, submit, ...fields, ...(shipping ? [shipping] : [])];
        if (known.some(node => !node) || new Set(known).size !== known.length) return;
        rememberContainer(state, layout);
        reorderDelivery(state, layout, true);
        const note = deliveryNote(layout);
        const orderedFields = fieldsWithDeliveryNote(layout, true, fields, note);
        const checkboxes = Array.from(layout.querySelectorAll('input[type="checkbox"]')).map(input => topBlock(layout, input)).filter((node, index, all) => node && !known.includes(node) && all.indexOf(node) === index);
        const desired = [offers, summary, ...(shipping ? [shipping] : []), ...orderedFields, ...checkboxes];
        if (!relativeOrder(layout, desired.concat(submit))) desired.forEach(node => moveNative(state, node, layout, submit));
        ownAttribute(state, layout, 'data-cu-candela-cod-ordered', '');
        return;
      }
      const desktop = form.querySelector('.rsi-layout-desktop');
      if (desktop) {
        const first = desktop.querySelector('.rsi-layout-desktop-first'), second = desktop.querySelector('.rsi-layout-desktop-second');
        if (!first || !second || first.parentElement !== desktop || second.parentElement !== desktop) return;
        const delivery = first.querySelector('.rsi-layout-desktop-top'), shipping = first.querySelector('.rsi-layout-desktop-bottom');
        const offers = topBlock(second, second.querySelector('.rsi-product-details-quantity-wrapper'));
        const summary = topBlock(second, second.querySelector('.rsi-total-summary-wrapper'));
        const submit = topBlock(second, second.querySelector('.rsi-custom-button-wrapper'));
        if (!delivery || !shipping || !offers || !summary || !submit || new Set([offers, summary, submit]).size !== 3 || !shipping.querySelector('.rsi-shipping-rates-wrapper') || !submit.querySelector('.rsi-submit_button') || delivery.parentElement !== first || shipping.parentElement !== first) return;
        const fields = fieldBlocks(delivery, false);
        if (fields.some(node => !node) || new Set(fields).size !== fields.length) return;
        rememberContainer(state, first); rememberContainer(state, second);
        const extras = Array.from(first.childNodes).filter(node => node !== delivery && node !== shipping);
        [offers, summary, shipping, delivery, ...extras].forEach(node => moveNative(state, node, second, submit));
        reorderDelivery(state, delivery, false);
        ownAttribute(state, desktop, 'data-cu-candela-cod-ordered', '');
        return;
      }
      const tablet = form.querySelector('.rsi-layout-tablet');
      if (tablet) {
        const first = tablet.querySelector('.rsi-layout-tablet-first'), second = tablet.querySelector('.rsi-layout-tablet-second');
        if (!first || !second || first.parentElement !== tablet || second.parentElement !== tablet) return;
        const fields = fieldBlocks(first, false);
        const offers = topBlock(second, second.querySelector('.rsi-product-details-quantity-wrapper'));
        const summary = topBlock(second, second.querySelector('.rsi-total-summary-wrapper'));
        const shipping = topBlock(second, second.querySelector('.rsi-shipping-rates-wrapper'));
        const submit = topBlock(second, second.querySelector('.rsi-submit_button'));
        if (fields.some(node => !node) || new Set(fields).size !== fields.length || !offers || !summary || !shipping || !submit || new Set([offers, summary, shipping, submit]).size !== 4) return;
        rememberContainer(state, first); rememberContainer(state, second);
        reorderDelivery(state, first, false);
        [offers, summary, shipping, ...Array.from(first.childNodes)].forEach(node => moveNative(state, node, second, submit));
        ownAttribute(state, tablet, 'data-cu-candela-cod-ordered', '');
        return;
      }
      const layouts = Array.from(form.querySelectorAll('.rsi-layout-wrapper')).filter(visible);
      if (layouts.length !== 1) return;
      const layout = layouts[0], fields = fieldBlocks(layout, false);
      const offers = topBlock(layout, layout.querySelector('.rsi-product-details-quantity-wrapper'));
      const summary = topBlock(layout, layout.querySelector('.rsi-total-summary-wrapper'));
      const shipping = topBlock(layout, layout.querySelector('.rsi-shipping-rates-wrapper'));
      const submit = topBlock(layout, layout.querySelector('.rsi-submit_button'));
      if (fields.some(node => !node) || new Set(fields).size !== fields.length || !offers || !summary || !shipping || !submit || new Set([offers, summary, shipping, submit]).size !== 4) return;
      rememberContainer(state, layout);
      reorderDelivery(state, layout, false);
      const note = deliveryNote(layout);
      const orderedFields = fieldsWithDeliveryNote(layout, false, fields, note);
      const checkboxes = Array.from(layout.querySelectorAll('input[type="checkbox"]')).map(input => topBlock(layout, input)).filter((node, index, all) => node && !orderedFields.includes(node) && ![offers, summary, shipping, submit].includes(node) && all.indexOf(node) === index);
      const desired = [offers, summary, shipping, ...orderedFields, ...checkboxes];
      if (!relativeOrder(layout, desired.concat(submit))) desired.forEach(node => moveNative(state, node, layout, submit));
      ownAttribute(state, layout, 'data-cu-candela-cod-ordered', '');
    });
  }

  function restoreNativeBlocks(modal) {
    const state = layoutStates.get(modal);
    if (!state) return;
    preserveFocus(modal, () => {
      state.moves.slice().reverse().forEach(entry => {
        if (!entry.node.isConnected || !entry.parent?.isConnected || !modal.contains(entry.parent)) return;
        const anchor = entry.next?.parentElement === entry.parent ? entry.next : null;
        if (entry.node.parentElement !== entry.parent || entry.node.nextSibling !== anchor) entry.parent.insertBefore(entry.node, anchor);
      });
      state.snapshots.slice().reverse().forEach(entry => {
        if (!entry.container.isConnected) return;
        const original = entry.nodes.filter(node => node.isConnected && node.parentElement === entry.container);
        const fresh = Array.from(entry.container.childNodes).filter(node => !original.includes(node));
        placeOrder(entry.container, original.concat(fresh));
      });
      state.texts.forEach(entry => { if (entry.node.isConnected && entry.node.nodeValue === entry.after) entry.node.nodeValue = entry.before; });
      state.attributes.forEach(entry => {
        if (!entry.node.isConnected || entry.node.getAttribute(entry.name) !== entry.after) return;
        if (entry.before == null) entry.node.removeAttribute(entry.name); else entry.node.setAttribute(entry.name, entry.before);
      });
    });
    layoutStates.delete(modal);
  }

  function mountTrust(form, modal) {
    const first = form.querySelector('[id="' + (isLegacy(modal) ? '_rsi-field-' : '') + 'first_name"]');
    const field = first && first.closest('.rsi-text-input-wrapper, ._rsi-modal-fields-item');
    if (!field) return;
    let layout = isLegacy(modal) ? field.parentElement : field.closest('.rsi-layout-desktop-top, .rsi-layout-tablet-second, .rsi-layout-wrapper');
    if (!layout || !form.contains(layout)) return;
    const anchor = topBlock(layout, field);
    if (!anchor) return;
    let trust = form.querySelector('[data-cu-candela-cod-trust]');
    if (!trust) {
      trust = document.createElement('div');
      trust.className = 'cu-candela-cod-trust';
      trust.setAttribute('data-cu-candela-cod-trust', '');
      trust.setAttribute('aria-label', 'Información de tu compra');
      trust.innerHTML = '<div class="cu-candela-cod-trust-icons" aria-hidden="true"><span>' + icon('truck') + '</span><span>' + icon('cash') + '</span><span>' + icon('shield') + '</span></div><div class="cu-candela-cod-trust-captions"><strong>Envío gratis<small>En paquetes de 2 y 3</small></strong><strong>Paga al recibir</strong><strong>Garantía<small>Según política</small></strong></div>';
    }
    if (trust.parentElement !== layout || trust.nextElementSibling !== anchor) layout.insertBefore(trust, anchor);
  }

  function safePolicyUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /^\/policies\//.test(url.pathname) ? url.pathname + url.search : null;
    } catch (_) { return null; }
  }

  function mountReminder(form) {
    if (form.querySelector('[data-cu-candela-cod-reminder]')) return;
    const submit = form.querySelector('.rsi-submit_button, button._rsi-modal-submit-button._rsi-buy-now-button[type="submit"]');
    const owner = submit && (submit.closest('.rsi-custom-button-wrapper, ._rsi-build-block-submit-button') || submit.parentElement);
    if (!owner || !owner.parentElement) return;
    const reminder = document.createElement('aside');
    reminder.className = 'cu-candela-cod-reminder';
    reminder.setAttribute('data-cu-candela-cod-reminder', '');
    reminder.setAttribute('aria-label', 'Por qué comprar en CosaÚtil');
    const heading = document.createElement('h3');
    heading.textContent = '¿Por qué comprar en CosaÚtil?';
    const text = document.createElement('p');
    text.textContent = 'Compra útil. Compra tranquila.';
    reminder.append(heading, text);
    const grid = document.createElement('div');
    grid.className = 'cu-candela-cod-trust-grid';
    grid.innerHTML = '<article>' + icon('star') + '<div><strong>Productos seleccionados</strong><p>Soluciones prácticas para tu rutina de cuidado.</p></div></article><article>' + icon('truck') + '<div><strong>Envío gratis</strong><p>En paquetes de 2 y 3, sujeto a cobertura.</p></div></article><article>' + icon('cash') + '<div><strong>Pago contra entrega</strong><p>Pagas al recibir en la dirección confirmada.</p></div></article><article>' + icon('shield') + '<div><strong>Garantía</strong><p>Si tu pedido llega con una falla o novedad, te ayudamos según nuestra política.</p></div></article>';
    const security = document.createElement('strong');
    security.className = 'cu-candela-cod-security';
    security.textContent = 'Tu seguridad es nuestra prioridad';
    reminder.append(grid, security);
    const links = document.createElement('nav');
    links.className = 'cu-candela-cod-policies';
    links.setAttribute('aria-label', 'Políticas de CosaÚtil');
    [['refund', 'Consulta la garantía'], ['shipping', 'Cobertura y entrega']].forEach(([key, title]) => {
      const url = safePolicyUrl(config.policies && config.policies[key]);
      if (!url) return;
      const link = document.createElement('a');
      link.href = url; link.target = '_blank'; link.rel = 'noopener'; link.textContent = title;
      links.appendChild(link);
    });
    if (links.children.length) reminder.appendChild(links);
    owner.insertAdjacentElement('afterend', reminder);
  }

  function decorateReferenceDetails(modal, form) {
    const state = layoutState(modal);
    const heading = form.querySelector('.rsi-form-title-container, .rsi-form-title, .rsi-form-header-title, .rsi-form-page-title, ._rsi-modal-header-title');
    if (heading) ownText(state, directText(heading) || directText(heading.querySelector('span')), '🔥 Reserva tu promoción Pago Contra Entrega');
    const confirmation = Array.from(form.querySelectorAll('input[type="checkbox"]')).find(input => input.getAttribute('data-type') === config.confirmationCheckboxType && /Confirmaremos tu pedido por WhatsApp antes del despacho\./.test(input.name));
    const checkboxLabel = confirmation && (confirmation.closest('label') || form.querySelector('label[for="' + confirmation.id + '"]') || confirmation.parentElement);
    if (checkboxLabel && !checkboxLabel.querySelector('[data-cu-candela-cod-whatsapp-note]')) {
      const span = Array.from(checkboxLabel.querySelectorAll('span')).find(node => /Confirmaremos tu pedido por WhatsApp antes del despacho\./.test(node.textContent)) || checkboxLabel;
      const source = directText(span);
      if (source && /Confirmaremos tu pedido por WhatsApp antes del despacho\./.test(source.nodeValue)) {
        ownText(state, source, '📲 Confirmaremos por WhatsApp tu pedido y la cobertura de tu dirección antes del despacho.');
        const note = document.createElement('small');
        note.className = 'cu-candela-cod-whatsapp-note';
        note.setAttribute('data-cu-candela-cod-whatsapp-note', '');
        note.textContent = 'Por favor, asegúrate de que tu número esté correcto y disponible para recibir mensajes.';
        checkboxLabel.appendChild(note);
      }
    }
    const submit = form.querySelector('.rsi-submit_button, button._rsi-modal-submit-button[type="submit"]');
    if (!submit) return;
    if (!submit.querySelector('[data-cu-candela-cod-cart-icon]')) {
      const cart = document.createElement('span');
      cart.className = 'cu-candela-cod-cart-icon';
      cart.setAttribute('data-cu-candela-cod-cart-icon', '');
      cart.setAttribute('aria-hidden', 'true');
      cart.innerHTML = icon('cart');
      const content = submit.querySelector('.rsi-custom-button-content');
      if (content) submit.insertBefore(cart, content); else submit.insertBefore(cart, submit.firstChild);
    }
    Array.from(submit.children).forEach(child => {
      if (child.tagName === 'DIV' && !child.classList.contains('rsi-custom-button-content') && !child.textContent.trim() && !child.querySelector('svg,img,input,select,textarea,button')) ownAttribute(state, child, 'data-cu-candela-reference-empty-spacer', '');
    });
    if (isLegacy(modal) && !submit.querySelector('[data-cu-candela-cod-submit-note]')) {
      const content = Array.from(submit.children).find(child => child.tagName === 'SPAN' && !child.hasAttribute('data-cu-candela-cod-cart-icon'));
      if (content) {
        const note = document.createElement('small');
        note.className = 'cu-candela-cod-submit-note';
        note.setAttribute('data-cu-candela-cod-submit-note', '');
        note.textContent = 'Pago Contra Entrega !';
        content.appendChild(note);
      }
    }
  }

  function packImageUrl(quantity) {
    const value = config.packImages && config.packImages[String(quantity)];
    if (typeof value !== 'string' || ![1, 2, 3].includes(quantity)) return null;
    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') return null;
      url.searchParams.set('width', '240');
      url.searchParams.set('format', 'webp');
      return url.href;
    } catch (_) { return null; }
  }

  // Match the actual visible offer quantity, never its position or current price.
  // Keep the native business DOM and restore native images if leaving Candela.
  function applyPackImage(image, quantity) {
    const url = packImageUrl(quantity);
    if (!image || !url) return;
    if (!packImageStates.has(image)) {
      const attributes = {};
      ['src', 'srcset', 'sizes', 'alt'].forEach(name => { attributes[name] = image.getAttribute(name); });
      packImageStates.set(image, {attributes, applied: null});
    }
    const state = packImageStates.get(image);
    state.applied = url;
    setAttribute(image, 'src', url);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    if (image.hasAttribute('sizes')) image.removeAttribute('sizes');
    setAttribute(image, 'alt', 'CANDELA 300 ml · ' + quantity + (quantity === 1 ? ' tarro' : ' tarros'));
    setAttribute(image, 'data-cu-candela-pack-quantity', String(quantity));
  }

  // This is the specific transactional WhatsApp reminder requested by the store
  // owner, not marketing, privacy or terms consent. Apply once to a new control;
  // a customer's unchecked choice survives subsequent app renders/pack changes.
  function defaultOrderConfirmation(form) {
    if (config.defaultConfirmationChecked !== true || !config.confirmationCheckboxType) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(input => {
      if (input.getAttribute('data-type') !== config.confirmationCheckboxType ||
          !/Confirmaremos tu pedido por WhatsApp antes del despacho\./.test(input.name) ||
          input.disabled || confirmationStates.has(input)) return;
      const state = {before: input.checked, edited: false, applied: null, listener: null};
      state.listener = () => {
        if (!applyingConfirmationDefault) {
          state.edited = true;
          confirmationChoice = input.checked;
        }
      };
      confirmationStates.set(input, state);
      input.addEventListener('change', state.listener);
      const desired = confirmationChoice == null ? true : confirmationChoice;
      state.applied = desired;
      if (input.checked !== desired) {
        applyingConfirmationDefault = true;
        try { input.click(); } finally { applyingConfirmationDefault = false; }
      }
    });
  }

  function restorePackImagesAndConfirmation() {
    packImageStates.forEach((state, image) => {
      if (image.getAttribute('src') === state.applied) {
        Object.keys(state.attributes).forEach(name => {
          if (state.attributes[name] == null) image.removeAttribute(name);
          else image.setAttribute(name, state.attributes[name]);
        });
      }
      image.removeAttribute('data-cu-candela-pack-quantity');
    });
    packImageStates.clear();
    confirmationStates.forEach((state, input) => {
      input.removeEventListener('change', state.listener);
      if (!state.edited && input.isConnected && input.checked === state.applied && input.checked !== state.before) input.click();
    });
    confirmationStates.clear();
    confirmationChoice = null;
  }

  function decorateOffers(modal) {
    if (isLegacy(modal)) {
      modal.querySelectorAll(LEGACY_OFFER_SELECTOR).forEach(label => {
        addClass(label, 'cu-candela-cod-offer');
        const quantity = quantityFromTitle(label.querySelector('._rsi-quantity-offers-title')?.textContent);
        applyPackImage(label.querySelector('img._rsi-modal-line-item-image'), quantity);
      });
      return;
    }
    modal.querySelectorAll(NATIVE_OFFER_SELECTOR).forEach(label => {
      addClass(label, 'cu-candela-cod-offer');
      const title = label.querySelector('.rsi-quantity-title');
      const titleWrapper = title && title.closest('.rsi-quantity-title-wrapper');
      const price = label.querySelector('.rsi-quantity-price-container');
      const info = titleWrapper && titleWrapper.parentElement;
      const head = info && info.parentElement;
      if (!head || !price || !head.contains(price) || info.contains(price)) return;
      const plaque = label.querySelector('.rsi-quantity-plaque');
      const plaqueBox = plaque && plaque.parentElement;
      if (plaqueBox && plaqueBox !== price && plaqueBox.parentElement === price && !plaqueBox.querySelector('input,select,textarea,button')) moveNative(layoutState(modal), plaqueBox, titleWrapper, null);
      // Use the quantity-specific photograph while preserving the native DOM.
      // An unknown offer may still fall back to the ordinary product photograph.
      const existing = head.querySelector('img');
      if (existing) {
        addClass(existing, 'cu-candela-cod-offer__image');
        applyPackImage(existing, quantityFromTitle(title?.textContent));
        // Do not flatten or move native business DOM to fit a guessed structure.
        if (existing.parentElement === head) {
          addClass(head, 'cu-candela-cod-offer__head');
          addClass(info, 'cu-candela-cod-offer__info');
        }
        return;
      }
      let imageUrl;
      if (typeof config.productImage !== 'string' || !config.productImage.trim()) return;
      try {
        imageUrl = new URL(config.productImage, window.location.origin);
        if (imageUrl.protocol !== 'https:') return;
      } catch (_) { return; }
      addClass(head, 'cu-candela-cod-offer__head');
      addClass(info, 'cu-candela-cod-offer__info');
      const image = document.createElement('img');
      image.className = 'cu-candela-cod-offer__image';
      image.setAttribute('data-cu-candela-cod-image', '');
      image.src = imageUrl.href;
      image.alt = 'CANDELA 300 ml · imagen del producto, revisa la cantidad elegida';
      image.width = 78; image.height = 78; image.loading = 'lazy';
      applyPackImage(image, quantityFromTitle(title?.textContent));
      head.insertBefore(image, info);
    });
  }

  function decorateLegacyFields(modal, form) {
    const fields = {first_name: 'user', last_name: 'user', phone: 'phone', address: 'home', civic_number: 'note', province_country_field: 'pin', city: 'pin', note: 'note'};
    const hasLastName = Boolean(form.querySelector('[id="_rsi-field-last_name"]'));
    const hasReference = Boolean(form.querySelector('[id="_rsi-field-note"]'));
    const placeholders = {first_name: hasLastName ? 'Nombre' : 'Nombre y apellido', last_name: 'Apellido', phone: 'Ej. 300 123 4567', address: 'Calle/carrera, número', civic_number: hasReference ? 'Barrio' : 'Barrio o referencia'};
    Object.keys(fields).forEach(name => {
      const control = form.querySelector('[id="_rsi-field-' + name + '"]');
      const wrapper = control && control.closest('._rsi-modal-fields-item');
      if (!wrapper || !form.contains(wrapper)) return;
      if (placeholders[name]) {
        if (!fieldPlaceholders.has(control)) fieldPlaceholders.set(control, {before: control.getAttribute('placeholder'), applied: placeholders[name]});
        setAttribute(control, 'placeholder', placeholders[name]);
      }
      addClass(wrapper, 'cu-candela-cod-field');
      const label = Array.from(wrapper.children).find(node => node.matches('label'));
      if (label) setAttribute(label, 'for', control.id);
      if (!wrapper.querySelector('[data-cu-candela-cod-field-icon]')) {
        const fieldIcon = document.createElement('span');
        fieldIcon.className = 'cu-candela-cod-field__icon';
        fieldIcon.setAttribute('data-cu-candela-cod-field-icon', '');
        fieldIcon.setAttribute('aria-hidden', 'true');
        fieldIcon.innerHTML = icon(fields[name]);
        wrapper.appendChild(fieldIcon);
      }
    });
    presentationStyle(form.querySelector('._rsi-modal-header-title'), 'color', '#321c25');
    const discountLabel = form.querySelector('[data-checkout-line="discount"] ._rsi-modal-checkout-line-title');
    if (discountLabel && discountLabel.firstChild && discountLabel.firstChild.nodeType === Node.TEXT_NODE && /^Discounts\s*$/.test(discountLabel.firstChild.textContent)) ownText(layoutState(modal), discountLabel.firstChild, 'Descuento ');
    const submit = form.querySelector('button._rsi-modal-submit-button._rsi-buy-now-button[type="submit"]');
    presentationStyle(submit, 'background', '#9f143c');
    presentationStyle(submit, 'border', '1px solid #9f143c');
    presentationStyle(submit, 'border-radius', '26px');
    presentationStyle(submit, 'box-shadow', '0 2px 7px rgba(50,28,37,.3)');
  }

  function cleanup(modal) {
    if (!modal) return;
    modal.querySelectorAll('[' + OWN_PREFIX + '-trust],[' + OWN_PREFIX + '-reminder],[' + OWN_PREFIX + '-image],[' + OWN_PREFIX + '-field-icon],[' + OWN_PREFIX + '-whatsapp-note],[' + OWN_PREFIX + '-cart-icon],[' + OWN_PREFIX + '-submit-note]').forEach(node => node.remove());
    restoreNativeBlocks(modal);
    if (modal.classList.contains('cu-candela-cod')) modal.classList.remove('cu-candela-cod');
  }

  function decorate() {
    queued = false;
    const modal = openModal();
    if (!activeProduct()) {
      pendingQuantity = null;
      document.querySelectorAll(MODAL_SELECTOR).forEach(cleanup);
      restorePresentationStyles();
      restorePackImagesAndConfirmation();
      restoreFieldPlaceholders();
      if (floatingButton) { floatingButton.remove(); floatingButton = null; }
      document.querySelectorAll('.cu-candela-cta-motion').forEach(node => node.classList.remove('cu-candela-cta-motion'));
      return;
    }
    const opener = nativeOpener();
    addClass(opener, 'cu-candela-cta-motion');
    presentationStyle(opener, 'background', '#9f143c');
    presentationStyle(opener, 'border', '1px solid #9f143c');
    presentationStyle(opener, 'border-radius', '12px');
    presentationStyle(opener, 'box-shadow', '0 4px 0 #77102d');
    syncFloatingButton(opener, modal);
    if (!modal) return;
    const form = modal.querySelector(FORM_SELECTOR);
    if (!form || (form.dataset.page && form.dataset.page !== 'fields')) return;
    addClass(modal, 'cu-candela-cod');
    orderNativeBlocks(modal, form);
    mountTrust(form, modal);
    mountReminder(form);
    decorateOffers(modal);
    defaultOrderConfirmation(form);
    if (isLegacy(modal)) decorateLegacyFields(modal, form);
    decorateReferenceDetails(modal, form);
    modal.querySelectorAll('.rsi-total-summary-wrapper, ._rsi-build-block-totals-summary').forEach(summary => {
      setAttribute(summary, 'role', 'region');
      setAttribute(summary, 'aria-label', 'Resumen del pedido: revisa el total antes de confirmar');
    });
    applyRequestedOffer(modal);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(decorate);
  }

  document.addEventListener('click', event => {
    if (!activeProduct() || !event.target.closest) return;
    const custom = event.target.closest('[data-cu-candela-cod-open]');
    if (custom && custom.closest(PRODUCT_SELECTOR)) { event.preventDefault(); open(); return; }
    const nativeProductButton = event.target.closest('#_rsi-buy-now-button._rsi-buy-now-button-product');
    if (nativeProductButton && !nativeProductButton.closest(MODAL_SELECTOR)) {
      // Releasit may visually overlay its native opener over the theme button.
      // Capture the landing pack for that direct customer click as well; let the
      // app's own existing handler open the modal, without a second click.
      pendingQuantity = selectedQuantity();
      selectionDeadline = Date.now() + 6000;
      schedule();
    }
    if (event.isTrusted && event.target.closest(MODAL_SELECTOR) && event.target.closest(NATIVE_OFFER_SELECTOR + ', ' + LEGACY_OFFER_SELECTOR)) pendingQuantity = null;
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.closest || !record.target.closest('[data-cu-candela-cod-trust],[data-cu-candela-cod-reminder]'))) schedule();
  });
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'data-page', 'checked', 'aria-hidden', 'src', 'srcset']});
  // Capture scroll events from the actual .page-wrapper as well as window.
  document.addEventListener('scroll', schedule, {passive: true, capture: true});
  window.addEventListener('resize', schedule, {passive: true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive: true});
  window.CosaUtilCandelaCOD = Object.freeze({open, refresh: schedule});
  schedule();
})();
